export default "__VITE_ASSET__fae1dfc3__"